import { TXCategoryFilterTemplate } from "../../../types/common/templates.types";

export const X_CATEGORY_FILTER_TEMPLATE1: TXCategoryFilterTemplate = {
  "Filtre par Defaut": {
    template: [
      {
        name: "XCategoryFilter",
        props: {
          all: {},
        },
      },
    ],
  },
};
